<template>
  <div>
    <TimerControl @subcommand="subcommand"></TimerControl>
  </div>
</template>

<script>
import BaseSlide from './BaseSlide';
import TimerControl from "../controls/TimerControl";

export default {
	name: 'SingleColorSinglePlanetSlide',
	mixins: [BaseSlide],
  components: {
	  TimerControl
  },
};
</script>

<style></style>
